// extracted by mini-css-extract-plugin
module.exports = {"Box":"CustomFadeBox_Box__2FkxC","Div":"CustomFadeBox_Div__2sht_","LargeDiv":"CustomFadeBox_LargeDiv__3tI6s"};